import { render } from "./EditBlock.vue?vue&type=template&id=35eaab64"
import script from "./EditBlock.vue?vue&type=script&lang=js"
export * from "./EditBlock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__